var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LOCAL_STORAGE_SETTINGS_KEY } from '../constants';
import loadLocalStorageSettings from './loadLocalStorageSettings';
var saveLocalStorageSettings = function (settings) {
    var currentLocalStorageSettings = loadLocalStorageSettings() || {};
    try {
        var newSettings = __assign(__assign({}, currentLocalStorageSettings), settings);
        localStorage.setItem(LOCAL_STORAGE_SETTINGS_KEY, JSON.stringify(newSettings));
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
    }
};
export default saveLocalStorageSettings;
